import { createTheme } from "@mui/material";
import { styleOverrides as accordion_styleOverrides } from "./accordion";
import { styleOverrides as accordionDetails_styleOverrides } from "./accordionDetails";
import { styleOverrides as accordionSummary_styleOverrides } from "./accordionSummary";
import { variants as button_variants } from "./button";
import { styleOverrides as divider_styleOverrides } from "./divider";
import { variants as iconButton_variants } from "./iconButton";
import { getPalette } from "./palette";
import { variants as paper_variants } from "./paper";
import { variants as tab_variants } from "./tab";
import { variants as tabs_variants } from "./tabs";
import { styleOverrides as textfield_styleOverrides } from "./textfield";
import { defaultProps as tooltip_defaultProps, styleOverrides as tooltip_styleOverrides } from "./tooltip";
import { typography, variants as typography_variants } from "./typography";
import { styleOverrides as alert_styleOverrides } from "./alert";

const createAppTheme = (mode) => {
  const palette = getPalette(mode);
  return createTheme({
    palette: palette,
    typography: typography,
    components: {
      MuiTypography: {
        variants: typography_variants,
      },
      MuiPaper: {
        variants: paper_variants,
      },
      MuiTooltip: {
        defaultProps: tooltip_defaultProps,
        styleOverrides: tooltip_styleOverrides,
      },
      MuiAccordion: {
        styleOverrides: accordion_styleOverrides,
      },
      MuiAccordionSummary: {
        styleOverrides: accordionSummary_styleOverrides,
      },
      MuiAccordionDetails: {
        styleOverrides: accordionDetails_styleOverrides,
      },
      MuiTabs: {
        variants: tabs_variants,
      },
      MuiTab: {
        variants: tab_variants,
      },
      MuiDivider: {
        styleOverrides: divider_styleOverrides,
      },
      MuiIconButton: {
        variants: iconButton_variants,
      },
      MuiButton: {
        variants: button_variants,
      },
      MuiTextField: {
        styleOverrides: textfield_styleOverrides,
      },
      MuiAlert: {
        styleOverrides: alert_styleOverrides,
      },
    },
  });
};

export default createAppTheme;
